import React from 'react';
import CrimeCard from "./component/CrimeCard";
import {
  makeStyles,
  List,
  ListItem,
  Typography,
  Box,
} from '@material-ui/core';
import idb from './helper/db';
import User from './model/User';
import Crime from './model/Crime';
import { modes } from './CrimeDetail';
const useStyles = makeStyles(theme => ({
  dummyContent: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
  },
  item: {
    margin: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  }
}));

const CrimeList: React.FC = () => {
  const user = new User();
  const db = new idb();
  const classes = useStyles();

  const [crimes, setCrimes] = React.useState<Crime[]>([]);

  const refreshList = () => {
    db.crimeTable.toArray().then((crimes: Crime[]) => {
      setCrimes(crimes);
    });
  }
  const renderDemoMode = () => {
    return <Typography className={classes.dummyContent} color="error" >~~~ ТЕСТОВЫЙ РЕЖИМ ~~~</Typography>
  }
  const renderEmptyLabel = () => {
    return <Typography className={classes.dummyContent} >Журнал пока пуст</Typography>
  }
  const handleEditCrime = (uuid: string) => {
    window.location.href = ("#detail/" + modes.edit + "/" + uuid);
  }
  const handleCopyCrime = (uuid: string) => {
    window.location.href = ("#detail/" + modes.copy + "/" + uuid);
  }
  const handleDeleteCrime = (uuid: string) => {
    if (window.confirm("Удалить замечание?")) {
      db.crimeTable.delete(uuid).then(() => {
        refreshList();
      });
    }
  }

  React.useEffect(() => {
    refreshList();
    // eslint-disable-next-line
  }, [])

  return (
    <Box>
      {user.isDemo() ? renderDemoMode() : null}
      {crimes.length === 0 ? renderEmptyLabel() :
        <List>
          {crimes.map((crime: Crime) => (
            <ListItem key={crime.uuid} className={classes.item} >
              <CrimeCard
                crime={crime}
                onEdit={handleEditCrime}
                onCopy={handleCopyCrime}
                onDelete={handleDeleteCrime} />
            </ListItem>
          ))}
        </List>
      }
    </Box>
  );
}
export default CrimeList;